export const frontmatter = {
  category: 'guia',
  title: 'O Que Levar para Ilha do Mel: Checklist Completo 2026',
  excerpt:
    'Não se esqueça de nada na sua viagem à Ilha do Mel. Checklist completo com itens essenciais, o que não precisa levar e dicas de moradores para viajar leve e tranquilo.',
  publishedAt: '2026-04-23',
  author: 'Guia Ilha do Mel',
  tags: ['checklist', 'dicas-praticas', 'o-que-levar'],
  coverImage: '/images/hero-bg.jpg',
  readingTime: '5 min',
};

# O Que Levar para [Ilha do Mel](/): Checklist Completo

A Ilha do Mel é um destino sem carros, sem caixa eletrônico e com infraestrutura limitada. **Viajar leve e preparado** faz toda a diferença entre uma viagem tranquila e uma série de contratempos.

Este checklist foi montado com dicas de moradores e de quem já passou por lá dezenas de vezes.

---

## Antes de sair de casa

### Documentos

- [ ] RG ou CNH (documento com foto)
- [ ] Comprovante de reserva da pousada
- [ ] Dinheiro em espécie (PIX funciona, mas o sinal é instável)
- [ ] Cartão de débito/crédito (para emergências em Paranaguá/Pontal)

> **Dica de morador:** leve pelo menos R$ 300-500 em espécie para uma estadia de 2-3 dias. Quase nenhum quiosque aceita cartão.

---

## Roupas e calçados

| Item                   | Quantidade | Observação                                      |
| ---------------------- | ---------- | ----------------------------------------------- |
| Biquíni/cueca de banho | 2-3        | Não seca rápido na umidade da ilha              |
| Toalha de praia        | 1          | Leve e de microfibra ocupa menos espaço         |
| Camisetas leves        | 3-4        | Algodão ou tecido técnico                       |
| Shorts                 | 2-3        | Para trilha e praia                             |
| Calça leve             | 1          | Para trilhas e noites frescas                   |
| Moletom/casaco fino    | 1          | Venta à noite, mesmo no verão                   |
| Chinelo                | 1 par      | Para o dia a dia na areia                       |
| Tênis de trilha        | 1 par      | **Obrigatório** para trilhas (não use sandália) |
| Chapéu/boné            | 1          | Proteção solar é essencial                      |
| Óculos de sol          | 1          | Com proteção UV                                 |

---

## Higiene e saúde

- [ ] Protetor solar **FPS 50+** (o sol reflete na areia e queima mais)
- [ ] Repelente de insetos
- [ ] Hidratante pós-sol
- [ ] Shampoo e sabonete (a pousada pode não fornecer)
- [ ] Escova de dentes e pasta
- [ ] Remédio para enjoo (travessia de barco pode balançar)
- [ ] Analgésico (dipirona/paracetamol)
- [ ] Curativos e antisséptico
- [ ] Preservativos (não há farmácia na ilha)

> **Atenção:** não há farmácia na Ilha do Mel. Leve todos os remédios que pode precisar.

---

## Eletrônicos

- [ ] Carregador de celular + power bank
- [ ] Fones de ouvido (a ilha é silenciosa — aproveite)
- [ ] Câmera fotográfica (opcional — o cenário pede)
- [ ] Lanterna ou celular com lanterna (ruas sem iluminação à noite)
- [ ] Adaptador de tomada (verifique com a pousada)

---

## Para a praia

- [ ] Máscara de snorkel (opcional — água é cristalina)
- [ ] Bolsa térmica pequena (para água e lanche)
- [ ] Garrafa de água reutilizável
- [ ] Sacola retornável (não há sacolas plásticas na ilha)
- [ ] Livro/e-reader (a praia convida a desconectar)

---

## O que NÃO levar

| Item                  | Por que deixar em casa                               |
| --------------------- | ---------------------------------------------------- |
| Mala com rodinha      | Ruas de areia e pedra — você vai carregar nas costas |
| Secador de cabelo     | Energia é preciosa e poucas pousadas aguentam        |
| Utensílios de cozinha | Não há cozinha compartilhada — coma nos restaurantes |
| Roupas de luxo        | Ambiente rústico e areia por toda parte              |
| Vale-refeição/VR      | Não aceitam em lugar nenhum                          |

---

## Mochila vs Mala: qual levar?

**Mochila é a melhor opção.** Sem exceção.

- Não há carros na ilha — você carrega tudo nas costas
- Ruas de areia, pedra e terra tornam malas com rodinha inúteis
- A travessia de barco exige que você carregue seus pertences até a pousada

> **Regra de ouro:** se você não consegue carregar sozinho por 1 km de trilha, não leve.

---

## Checklist rápido para 2 dias

```
☐ RG + reserva da pousada
☐ R$ 300-500 em espécie
☐ 2 biquínis + 3 camisetas + 2 shorts
☐ Tênis de trilha + chinelo
☐ Protetor solar FPS 50 + repelente
☐ Power bank + carregador
☐ Remédios básicos
☐ Mochila (não mala!)
```

---

## Dica final: viaje leve

A Ilha do Mel premia quem viaja com pouco. Menos bagagem = mais liberdade para explorar trilhas, subir no farol e caminhar entre vilarejos sem peso nas costas.

Quer saber [como chegar na Ilha do Mel](/blog/como-chegar), onde ficar e quanto custa? Nosso guia completo da [Ilha do Mel](/) tem roteiros prontos, orçamento por perfil e dicas de moradores para você planejar a viagem perfeita.
